import { ICancelTransferDetails, IBaseTransferDetails } from '../../../types';

export function formatCancelTransferResponse(
  data: ICancelTransferDetails
): IBaseTransferDetails {
  if (!data) {
    // Return an empty object or throw error as per your use case
    return {} as IBaseTransferDetails;
  }

  const {
    inventoryTransferId,
    inventoryTransferStatus,
    sourcePod,
    sourceTrayId,
    sourceTrayNumber,
    sourceZone,
    destinationPod,
    destinationZone,
    sourceWorkStationId,
    destinationWorkStationId,
    destinationWorkStationName,
    destinationIsCommonStation,
    totalInventories,
    noOfTrays,
  } = data;

  // Set title based on tray and destination scan status
  const isTray = !!sourceTrayNumber;
  const openTransferTitle = isTray
    ? `${sourceTrayNumber}, ${sourcePod}`
    : `All Trays in ${sourcePod}`;
  const isDestinationScanned = inventoryTransferStatus === 'IN_PROGRESS';
  const title = isDestinationScanned
    ? destinationWorkStationName
    : openTransferTitle;
  const barcode = isDestinationScanned
    ? sourceWorkStationId
    : sourcePod || sourceTrayNumber;

  return {
    barcode,
    destinationIsCommonStation,
    destinationPod,
    destinationWorkStationId,
    destinationWorkStationName,
    destinationZone,
    inventoryTransferId,
    isDestinationScanned,
    isPod: !isTray,
    packagesCount: totalInventories,
    sourcePod,
    sourceTrayId,
    sourceTrayNumber,
    sourceZone,
    title,
    traysCount: sourceTrayNumber ? undefined : noOfTrays,
    transferStatus: inventoryTransferStatus,
    workStationId: destinationWorkStationId,
    workStationProcessId: sourceWorkStationId,
    workStationZoneType: destinationPod,
  };
}
